import React, { useState } from "react";
import { MenuItem, TextField, Button } from "@mui/material";

function ReviewerInputs() {
  // State for form inputs
  const [formData, setFormData] = useState({
    amount: "",
    currentLevel: null,
    courseDuration: "",
    status: "",
    cgpa: "",
    comment: "",
  });

  // Handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Reviewer's Feedback</h2>
      <form className="space-y-4 text-left">
        <TextField
          label="Scholarship Amount"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

        <TextField
          label="Current Level"
          name="currentLevel"
          value={formData.currentLevel}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

        <TextField
          label="Course Duration"
          name="courseDuration"
          value={formData.courseDuration}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

        <TextField
          label="Status"
          name="status"
          value={formData.status}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

        <TextField
          label="CGPA"
          name="cgpa"
          value={formData.cgpa}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

        <TextField
          label="Reviewer's Comment"
          name="comment"
          value={formData.comment}
          onChange={handleChange}
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

        {/* Submit Button */}
        <Button variant="contained" color="primary" className="w-full">
          Submit
        </Button>
      </form>
    </div>
  );
}

export default ReviewerInputs;
